var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletmembership1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet-membership"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.0093 9.76333H5.11215V3.9412H22.0093M22.0093 14.6151H5.11215V12.6744H22.0093M22.0093 2.00049H5.11215C3.93991 2.00049 3 2.8641 3 3.9412V14.6151C3 15.6922 3.93991 16.5558 5.11215 16.5558H9.33645V21.4076L13.5607 19.4669L17.785 21.4076V16.5558H22.0093C23.1816 16.5558 24.1215 15.6922 24.1215 14.6151V3.9412C24.1215 2.8641 23.1816 2.00049 22.0093 2.00049Z",
    fill: "#E35205"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletmembership1);
export default __webpack_public_path__ + "static/media/walletmembership1.460612d9af86ba4b4810c6aaef3a345a.svg";
export { ForwardRef as ReactComponent };